module.exports = __webpack_public_path__ + "img/order-step9-b.919acc95.png";